import type { InjectionKey } from 'vue'

import { makeFormatters } from '#.shared/dates/utils/format'

export type IdGenerator = () => string
export const IdGenKey: InjectionKey<IdGenerator> = Symbol('idGen')

export const DateFormattersKey: InjectionKey<
  ReturnType<typeof makeFormatters>
> = Symbol('dateFormatters')
